import { select } from 'redux-saga/effects';

import { FORM_NAME as CREATE_FORM_NAME } from '../../views/CreateEvent/CreateEventForm/constants';
import { FORM_NAME as UPDATE_FORM_NAME } from '../../views/ManageEvents/ManageEventsBody/ManageEventsBodyForm/constants';

const getActiveCategory = state => state.activeCategory.value;
const getActiveManageEventId = state => state.activeManageEventId;
const getAuthUser = state => state.firebase.auth;
const getCreateFormValues = state => state.form[CREATE_FORM_NAME].values;
const getEvents = state => state.firestore.ordered.events;
const getUpdateFormValues = state => state.form[UPDATE_FORM_NAME].values;
const getUserEvents = state => state.firestore.ordered.userEvents;

const getActiveEvent = function* getActiveEvent() {
  const activeManageEventId = yield select(getActiveManageEventId);

  if (!activeManageEventId) {
    throw 'No event selected';
  }

  const userEvents = yield select(getUserEvents);
  return userEvents.find(event => {
    return activeManageEventId === event.id;
  });
};

export {
  getActiveCategory,
  getActiveManageEventId,
  getActiveEvent,
  getAuthUser,
  getCreateFormValues,
  getEvents,
  getUpdateFormValues,
  getUserEvents
}



// WEBPACK FOOTER //
// ./src/redux/sagas/selectors.js